import type { AppConfig } from '~/types/app'
import { OrganizationRoles } from '~/constants/organizations'
import { AppRoles } from '~/constants/user'

export const isSignUpDisabled = () => {
  const appConfig = useAppConfig() as AppConfig
  return appConfig.disableSignUp ?? false
}

export const currentUserCanCreateOrganization = () => {
  const appConfig = useAppConfig() as AppConfig
  return Number(appConfig.minimumRoleToCreateOrganization)
    ? isCurrentUserGrantedInApp(appConfig.minimumRoleToCreateOrganization)
    : isCurrentUserGrantedInApp(AppRoles.User)
}

export const currentUserCanCreateWorkspace = () => {
  const appConfig = useAppConfig() as AppConfig
  return isUserGrantedInOrganization(
    appConfig.minimumRoleToCreateWorkspace
    ?? isUserGrantedInOrganization(OrganizationRoles.User),
  )
}

export const getFormattedAppConfigMenuItems = (
  key: 'app' | 'organization' | 'user' | 'admin',
) => {
  if (key === 'admin' && !isCurrentUserGrantedInApp(AppRoles.Admin)) return []

  const appConfig = useAppConfig()
  const hasMenuItems = Object.hasOwnProperty.call(appConfig, 'menuItems')
    && Object.hasOwnProperty.call(appConfig.menuItems, key)

  if (hasMenuItems) {
    return Object.entries(appConfig.menuItems[key])
      .map(([organizationRole, menuItems]) => {
        if (key !== 'admin' && !isUserGrantedInOrganization(organizationRole))
          return []

        return menuItems.map((menuItem) => {
          const shadowMenuItem = { ...menuItem } // To prevent to apply updates on menuItem source

          if (key === 'organization' && shadowMenuItem.to) {
            shadowMenuItem.to = getOrganizationRoutePath(shadowMenuItem.to)
          }

          if (
            (key === 'app' || key === 'organization')
            && shadowMenuItem.items
          ) {
            shadowMenuItem.items = shadowMenuItem.items.map(item => ({
              ...item,
              ...(item.to && { to: getOrganizationRoutePath(item.to) }),
            }))
          }

          return shadowMenuItem
        })
      })
      .flat()
  }
  else {
    return []
  }
}
